export default "__VITE_ASSET__Cc4Ow6NI__"